import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { loadDeviceImagePlaceholder } from '@models/functions.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { DeviceItemCarrier, DeviceItemData, DeviceItemDevice } from '@models/shopping.model';
import { CustomizeService } from '@services/customize-service/customize.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-device-image-placeholder',
  templateUrl: './image-placeholder.component.html',
  imports: [CommonModule]
})
export class ImagePlaceholderComponent implements OnInit {
  @Input() device: DeviceItemDevice | DeviceItemCarrier;
  @Input() product_category: string;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(private customize_svc: CustomizeService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.customize_svc.cartChanges.subscribe(
        (res: ShoppingCartData) => (this.shopping_cart = res)
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getPlaceholder = (category: string, e: any): string => loadDeviceImagePlaceholder(category, e);
}
